@let vm = wallet();
@let iconSize = this.iconSize()[size()];

<div
  class="wallet"
  [ngClass]="'wallet-' + size()"
  [class.justify-center]="size() === 'xxs'"
>
  @if (size() === "xxs") {
    <span class="currency d-flex align-center justify-center">
      <fu-icon
        [size]="iconSize"
        [iconName]="currentWallet().currency?.symbol.toLowerCase() ?? ''"
      ></fu-icon>
    </span>
  } @else {
    <div class="wallet-header">
      @if (size() !== "m") {
        <span class="wallet-currency d-flex align-center">
          <fu-icon
            [size]="iconSize"
            [iconName]="vm.currency?.symbol?.toLowerCase() ?? ''"
          ></fu-icon>
          <span class="name"> {{ vm.currency?.name }}</span>
        </span>
      }
    </div>

    <div class="wallet-description d-flex flex-col gap-1">
      <div class="wallet-balance" [class.wallet-balance-m]="size() === 'm'">
        <span class="currency"> {{ vm?.currency?.symbol }}</span>
        @let balance = vm?.balance | decimal;
        {{ !useBalanceMask() ? balance : (balance | maskBalance) }}
      </div>
      <div class="wallet-name">Wallet {{ vm?.currency?.symbol }}</div>
    </div>
  }
</div>
